import type { Route } from '@angular/router';
import type { SchoolbellCallbackRouteData } from './schoolbell-callback.component';

export interface SchoolbellCallbackRouteOptions extends SchoolbellCallbackRouteData {
  /** 셸(헤더·푸터) 없이 그린다 — code 교환이 끝나는 즉시 이탈하는 처리 중 화면이라 셸을 건너뛰는 앱(`data.shellBare`)만 켠다. */
  shellBare?: boolean;
}

/**
 * schoolbell-e OIDC 로그인(및 단체 연동) redirect_uri 라우트 — `auth/sso/schoolbell-e/callback`. 이 경로는 학교종이 OAuth client에 등록된 값과 byte-exact로 같아야 하므로 앱마다 바꾸지 않는다.
 * 앱의 **인증 영역 밖**(guard 없음)에 펼친다.
 *
 * ```ts
 * schoolbellCallbackRoute({ returnPath: '/dashboard', shellBare: true })
 * ```
 *
 * 전제: 앱의 API base URL 인터셉터가 상대 경로 `/auth/sso/schoolbell-e/callback` 요청을 API 오리진으로 보내고, 백엔드가 `SpinoffProviderFederationModule.forRoot({ oidcRp })`로 이 엔드포인트를 연다.
 */
export function schoolbellCallbackRoute(options: SchoolbellCallbackRouteOptions = {}): Route {
  const { shellBare, ...routeData } = options;
  const data = {
    ...(shellBare ? { shellBare: true } : {}),
    ...(routeData.returnPath ? { returnPath: routeData.returnPath } : {}),
    ...(routeData.loginPath ? { loginPath: routeData.loginPath } : {}),
  };
  return {
    path: 'auth/sso/schoolbell-e/callback',
    data: Object.keys(data).length ? data : undefined,
    loadComponent: () => import('./schoolbell-callback.component').then((m) => m.SchoolbellCallbackComponent),
  };
}
